import api from './api';

export const getMyExpenses = (params) => api.get('/v1/expenses/my', { params });
export const getPendingExpenses = (params) => api.get('/v1/expenses/pending', { params });
export const getAllExpenses = (params) => api.get('/v1/expenses/all', { params });
export const getExpense = (id) => api.get(`/v1/expenses/${id}`);
export const createExpense = (data) => api.post('/v1/expenses', data);
export const cancelExpense = (id) => api.put(`/v1/expenses/${id}/cancel`);
export const approveExpense = (id) => api.put(`/v1/expenses/${id}/approve`);
export const rejectExpense = (id, reason) => api.put(`/v1/expenses/${id}/reject`, { rejectionReason: reason });
export const updatePaymentStatus = (id, paymentStatus) => api.put(`/v1/expenses/${id}/payment-status`, { paymentStatus });
